import { Routes } from '@angular/router';
import { authGuard } from '../guard/auth.guard';
import { CHCComponent } from '../mobile/pages/custom-hiring-center/chc.component';

export const customHiringCentreMobileRoutes: Routes = [
    {
        path: 'mobile/chc',
        component: CHCComponent,
        canActivate: [authGuard],
        children: [
            {
                path: 'home',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/chc-home/home.component').then(
                        (m) => m.ChcHomeComponent
                    )
            },
            {
                path: 'profile',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/chc-profiles/profiles.component').then(
                        (m) => m.ChcProfilesComponent
                    )
            },
            {
                path: 'activity',
                loadChildren: () =>
                    import('../mobile/pages/custom-hiring-center/chc-activity/chc-activity.routes').then(
                        (m) => m.CHC_ACTIVITY_ROUTES
                    )
            },
            {
                path: 'finance',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/chc-finance/chc-finance.component').then(
                        (m) => m.ChcFinanceComponent
                    )
            },
            {
                path: 'finance/:id',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/chc-view-finance/chc-view-finance.component').then(
                        (m) => m.ChcViewFinanceComponent
                    )
            },
            {
                path: 'finance/:id/tool-maintenance',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/chc-tool-maintenance/chc-tool-maintenance.component').then(
                        (m) => m.ChcToolMaintenanceComponent
                    )
            },
            {
                path: 'finance/:id/tool-maintenance/:toolId/history',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/chc-tool-maintenance-history/chc-tool-maintenance-history.component').then(
                        (m) => m.ChcToolMaintenanceHistoryComponent
                    )
            },
            {
                path: 'finance/:id/expense-history',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/chc-expense-history/chc-expense-history.component').then(
                        (m) => m.ChcExpenseHistoryComponent
                    )
            },
            {
                path: 'add',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/add-chc-form/add-chc.component').then(
                        (m) => m.AddChcComponent
                    )
            },
            {
                path: 'profile/:id',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/chc-view-profile/chc-view-profile.component').then(
                        (m) => m.ChcViewProfileComponent
                    )
            },
            {
                path: 'profile/:id/equipments',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/chc-equipments/chc-equipments.component').then(
                        (m) => m.ChcEquipmentsComponent
                    )
            },
            {
                path: 'profile/:id/funds',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/chc-funds/chc-funds.component').then(
                        (m) => m.ChcFundsComponent
                    )
            },
            {
                path: 'equipment/add/:chcId',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/add-chc-form/components/add-equipment/add-equipment.component').then(
                        (m) => m.AddEquipmentComponent
                    )
            },
            {
                path: 'equipment/edit/:chcId/:equipmentId',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/add-chc-form/components/add-equipment/add-equipment.component').then(
                        (m) => m.AddEquipmentComponent
                    )
            },
            {
                path: 'fund/add/:chcId',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/add-fund/add-fund.component').then(
                        (m) => m.AddFundComponent
                    )
            },
            {
                path: 'fund/edit/:chcId/:fundId',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/add-fund/add-fund.component').then(
                        (m) => m.AddFundComponent
                    )
            },
            {
                path: 'finance/tool-maintenance/add/:chcId',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/add-tool-maintenance/add-tool-maintenance.component').then(
                        (m) => m.AddToolMaintenanceComponent
                    )
            },
            {
                path: 'finance/tool-maintenance-history/:action/:chcId/:toolId',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/add-tool-maintenance-history/add-tool-maintenance-history.component').then(
                        (m) => m.AddToolMaintenanceHistoryComponent
                    )
            },
            {
                path: 'finance/expense-history/:action/:chcId',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/add-expense-history/add-expense-history.component').then(
                        (m) => m.AddExpenseHistoryComponent
                    )
            },
            {
                path: 'booking/list/:type',
                loadComponent: () =>
                    import('../mobile/pages/custom-hiring-center/chc-booking-list/chc-booking-list.component').then(
                        (m) => m.ChcBookingListComponent
                    )
            },
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full'
            }
        ]
    }
];

export const customHiringCentreAdminRoutes: Routes = [
    {
        path: 'chc-admin',
        canActivate: [authGuard],
        children: [
            {
                path: '',
                redirectTo: 'profiles',
                pathMatch: 'full'
            },
            {
                path: 'profiles',
                loadComponent: () =>
                    import('../chc-admin/profiles/chc-admin-profiles.component').then(
                        (m) => m.ChcAdminProfilesComponent
                    ),
                canActivate: [authGuard]
            },
            {
                path: 'bookings',
                loadComponent: () =>
                    import('../chc-admin/bookings/tools-booking/tools-booking.component').then(
                        (m) => m.ToolsBookingComponent
                    ),
                canActivate: [authGuard]
            },
            {
                path: 'bookings/:id',
                loadComponent: () =>
                    import('../chc-admin/bookings/list/chc-admin-booking-list.component').then(
                        (m) => m.ChcAdminBookingListComponent
                    ),
                canActivate: [authGuard]
            },
            {
                path: 'bookings/:chcId/booking/:bookingId',
                loadComponent: () =>
                    import('../chc-admin/bookings/detail/chc-admin-booking-detail.component').then(
                        (m) => m.ChcAdminBookingDetailComponent
                    ),
                canActivate: [authGuard]
            },
            {
                path: 'profiles/:id',
                loadComponent: () =>
                    import('../chc-admin/profile-detail/chc-admin-profile-detail.component').then(
                        (m) => m.ChcAdminProfileDetailComponent
                    ),
                canActivate: [authGuard]
            },
            {
                path: 'tool-maintenance',
                loadComponent: () =>
                    import('../chc-admin/tool-maintenance/tool-maintenance-list/tool-maintenance-list.component').then(
                        (m) => m.ToolMaintenanceListComponent
                    ),
                canActivate: [authGuard]
            },
            {
                path: 'tool-maintenance/:chcId',
                loadComponent: () =>
                    import('../chc-admin/tool-maintenance/tool-list/tool-list.component').then(
                        (m) => m.ToolListComponent
                    ),
                canActivate: [authGuard]
            },
            {
                path: 'tool-maintenance/:chcId/:toolId',
                loadComponent: () =>
                    import('../chc-admin/tool-maintenance/tool-maintenance-history/tool-maintenance-history.component').then(
                        (m) => m.ToolMaintenanceHistoryComponent
                    ),
                canActivate: [authGuard]
            },
            {
                path: 'expense',
                loadComponent: () =>
                    import('../chc-admin/expense/expense-list/expense-list.component').then(
                        (m) => m.ExpenseListComponent
                    ),
                canActivate: [authGuard]
            },
            {
                path: 'expense/:chcId',
                loadComponent: () =>
                    import('../chc-admin/expense/expense-history/expense-history.component').then(
                        (m) => m.ExpenseHistoryComponent
                    ),
                canActivate: [authGuard]
            }
        ]
    }
];
